<template>
  <div class="tabs header-container" :style="nav_theme" ref="myTabs">
    <div class="l-content">
      <!--收缩图标-->
      <div class="content-hamburger" @click="handleMenu">
        <svg :class="this.$store.state.tab.isCollapse
    ? 'hamburger is-active'
    : 'hamburger'
    " viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" width="64" height="64">
          <path
            d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z" />
        </svg>
      </div>
      <!--面包屑 v-if="this.IsMobile()=== null"-->
      <!-- <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="item in tags" :key="item.path" :to="{ path: item.path }">
          {{
            $t(item.label)
          }}
        </el-breadcrumb-item>
      </el-breadcrumb> -->
    </div>
    <div class="scroll-container" v-if="$route.path != '/JobTutorial_view'">
      <el-tag v-for="(item, index) in tags" :key="item.name" :id="item.name" :closable="item.name !== 'home'"
        :disable-transitions="true" :effect="$route.name === item.name ? 'plain' : 'dark'" @click="changeMenu(item)"
        @close="handleClose(item, index)" size="Medium">
        <span :class="$route.name === item.name ? 'tag-active' : ''"></span> {{ $t(item.label) }}
      </el-tag>
    </div>
    <div class="r-content">
      <Theme ref="theme" />
      <template v-if="this.IsMobile() == null">
        <div class="right-menu-item hover-effect">
          <el-tooltip :content="$t('_theme_switching')" effect="dark" placement="bottom">
            <svg-icon class-name="theme-icon" icon-class="theme" @click="showtheme" />
          </el-tooltip>
        </div>
        <div>
          <el-tooltip :content="$t('_full_screen')" effect="dark" placement="bottom">
            <Screenfull id="screenfull" class="right-menu-item hover-effect" />
          </el-tooltip>
        </div>
        <div>
          <el-tooltip :content="$t('_font_size')" effect="dark" placement="bottom">
            <Sizeselect id="size-select" class="right-menu-item hover-effect" />
          </el-tooltip>
        </div>
        <div>
          <el-tooltip :content="$t('_change_pwd')" effect="dark" placement="bottom">
            <el-button icon="el-icon-key" class="right-menu-item hover-effect" @click="changPsw"></el-button>
          </el-tooltip>
          <el-tooltip :content="$t('_exit')" effect="dark" placement="bottom" v-if="IsMobile() == null">
            <el-button icon="el-icon-switch-button" class="right-menu-item hover-effect" @click="handleClick('cancel')"  v-if="IsMobile() == null"></el-button>
          </el-tooltip>
        </div>
      </template>
      <el-dropdown v-else trigger="click" @command="handleCommand">
        <span class="el-dropdown-link">
          <i class="el-icon-setting el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="theme"><svg-icon class-name="theme-icon" icon-class="theme"
              @click="showtheme" /></el-dropdown-item>
          <el-dropdown-item command="screenfull">
            <Screenfull id="screenfull" class="right-menu-item hover-effect" />
          </el-dropdown-item>
          <el-dropdown-item command="size">
            <Sizeselect id="size-select" class="right-menu-item hover-effect" />
          </el-dropdown-item>
          <el-dropdown-item command="chgpsw" icon="el-icon-key"></el-dropdown-item>
          <el-dropdown-item command="logout" icon="el-icon-switch-button"></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog title="修改密碼" :visible.sync="dialogVisible" append-to-body :width="this.$store.getters.current_width"
      custom-class="center-dialog">
      <el-form :model="frmPsw">
        <el-form-item label="舊密碼" prop="oldPsw">
          <el-input prefix-icon="el-icon-unlock" type="password" maxlength="200" autocomplete="off"
            v-model="frmPsw.oldPsw" placeholder="請輸入舊密碼"></el-input>
        </el-form-item>
        <el-form-item label="新密碼" prop="newPsw">
          <el-input prefix-icon="el-icon-lock" type="password" maxlength="200" autocomplete="off"
            v-model="frmPsw.newPsw" placeholder="請輸入新密碼"></el-input>
        </el-form-item>
        <el-form-item label="確認新密碼" prop="newPsw">
          <el-input prefix-icon="el-icon-lock" type="password" maxlength="200" autocomplete="off"
            v-model="frmPsw.confirmPsw" placeholder="請重複新密碼"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="ChgPsw">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import Cookie from "js-cookie";
import { ChangePassword } from "@/api/rms86/login";
// 調用全屏組件
import Screenfull from "@/components/screenfull/Index.vue";
// 調用多語言切換組件
import Langselect from "@/components/langselect/Index.vue";
// 調用字體切換組件
import Sizeselect from "@/components/sizeselect/Index.vue";
// 調用主題組件
import Theme from "@/components/dialog/theme.vue";
import { IsMobile } from "@/script/common";
export default {
  components: { Screenfull, Langselect, Sizeselect, Theme },
  data() {
    return {
      frmPsw: {
        oldPsw: "",
        newPsw: "",
        confirmPsw: "",
      },
      dialogVisible: false,
    };
  },
  methods: {
    ...mapMutations(["closeTag"]),
    scrollTo(selector) {
      const element = document.querySelector(selector)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    // 跳轉最右側
    scrollToEnd() {
      window.scrollTo(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER) // 滚动到最右侧
    },
    // 点击tag跳转的功能
    changeMenu(item) {
      const index = this.tags.findIndex((val) => val != null && val.name === item.name);
      if (index === -1)
        this.scrollToEnd()
      else
        this.scrollTo(`#${item.name}`)
      // 增加頁面緩存
      if (this.$route.meta != undefined && this.$route.meta.istrun) {
        this.$store.dispatch('addCachedView', this.$route)
      }
      this.routePush(item, "");
      const del_index = this.breadcrumbList.findIndex(
        (item) => item.name !== "home"
      );
      // 处理更改选项卡动态更新面包屑
      if (del_index != -1) {
        this.breadcrumbList.splice(del_index, 1);
      }
      if (item.name != "home") {
        this.breadcrumbList.push(item);
      }
      this.$store.commit("get_current_label", item.label);
      if (this.IsMobile() != null) {
        this.$store.state.tab.isCollapse = true;
      }
    },
    //  点击tag删除的功能
    handleClose(item, index) {
      //调用mapMutations的closeTag 或者this.$store.commit
      this.closeTag({ item: item, type: 1 });
      const length = this.tags.length;
      // 删除之后的跳转逻辑
      if (item.name !== this.$route.name) {
        //路由不等光标位置就不变
        return;
      }
      else {
        // 清除当前路由m_code
        this.$store.commit('get_tab_code', "")
      }
      if (index === length) {
        //如果相等 就左移
        this.routePush(this.tags[index - 1], this.tags[index - 1].name);
      } else {
        this.routePush(this.tags[index], this.tags[index].name);
      }
      // 处理移除tag时，同时更新面包屑
      if (this.tags.length >= 1) {
        const del_index = this.breadcrumbList.findIndex(
          (item) => item.name !== "home"
        );
        this.breadcrumbList.splice(del_index, 1);
        if (this.tags[this.tags.length - 1].name != "home") {
          this.breadcrumbList.push(this.tags[this.tags.length - 1]);
        }
      }
    },
    // 路由參數跳轉
    routePush(item, name) {
      // 通过路由name或者地址跳转
      // 如果为undefined时为列表页
      if (item.params === undefined) {
        this.$router.push({ name: name != "" ? name : item.name, params: { type: item.type, right: (item.acode || "") } });
      }
      else
      // 切换修改页面需带参
      {
        if (item.params.actione_type === "add") {
          this.$router.push({ name: name != "" ? name : item.name, params: { actione_type: item.params.actione_type, LookupType: item.params.LookupType, right: (item.acode || "") } });
        }
        else {
          this.$router.push({ name: name != "" ? name : item.name, params: { actione_type: item.params.actione_type, id: item.params.id, sTable_name: item.params.sTable_name, LookupType: item.params.LookupType, right: (item.acode || "") } });
        }
      }
    },

    handleMenu() {
      this.$store.commit("collapseMenu"); // 通过挂载main.js获取store中点击事件
    },
    handleClick(command) {
      // dropdown事件回调必须通过标识指定执行
      if (command === "cancel") {
        // 清除cookie中的token信息
        Cookie.remove("token");
        // 清除cookie中的rms8_language_code
        //Cookie.remove(Cookie.get("current_login_id") + "language_code");
        localStorage.removeItem("menu");
        // 跳转至登录页
        this.$router.push("login");
      }
    },
    changPsw() {
      this.frmPsw.oldPsw = "";
      this.frmPsw.newPsw = "";
      this.frmPsw.confirmPsw = "";
      this.dialogVisible = true;
    },
    ChgPsw() {
      var msg = "";
      if (this.frmPsw.oldPsw.trim().length == 0)
        msg = "必須輸入舊密碼\n";
      if (this.frmPsw.newPsw.trim().length == 0)
        msg += "必須輸入新密碼";
      else {
        if (this.frmPsw.confirmPsw != this.frmPsw.newPsw)
          msg += "沒有確認新密碼";
      }
      if (msg.length > 0) {
        this.$message.warning(msg);
      }
      else {
        ChangePassword(this.frmPsw).then(data => {
          if (data.success == 1) {
            this.$message.info(data.message);
            this.dialogVisible = false;
          }
          else
            this.$message.error(data.message);
        });
      }
    },
    // 主題設置顯示
    showtheme() {
      this.$refs.theme.show();
    },
    set_theme(obj) {
      container = this.$refs.myTabs;
      container.style.backgroundColor = this.nav_theme["background"];
      container.style.color = this.nav_theme["color"];
      var element = container.querySelectorAll(obj);
      for (var i = 0; i < element.length; i++) {
        element[i].style.backgroundColor = this.nav_theme["background"];
        element[i].style.color = this.nav_theme["color"];
      }

      var element = container.querySelectorAll(".el-tag--plain");
      for (var i = 0; i < element.length; i++) {
        //element[i].style.backgroundColor = "";
        element[i].style.color = "black";
      }
    },
    handleCommand(command) {
      if (command == "chgpsw") this.changPsw();
      if (command == "logout") this.handleClick("cancel");
    },
  },
  computed: {
    ...mapState({
      // 面包屑加载菜单数据
      //tags: (state) => state.tab.breadcrumbList,
      tags: (state) => state.tab.tabList,
      breadcrumbList: (state) => state.tab.breadcrumbList,
      nextLabel: (state) => state.tab.next_label,
    }),
    // 導航主題
    nav_theme() {
      return this.$store.getters.current_nav_theme.background === undefined ? { "background": "#3c8dbc", "color": "#fff" } : this.$store.getters.current_nav_theme;
    },
    //  菜單主題
    menu_theme() {
      return this.$store.getters.current_menu_theme.background === undefined ? { "background": "#304156", "color": "rgb(191, 203, 217)" } : this.$store.getters.current_menu_theme;
    },
    //  菜單主題
    body_theme() {
      return this.$store.getters.current_body_theme.background === undefined ? { "background": "#ffffff", "color": "#606266" } : this.$store.getters.current_body_theme;
    },
    body_theme_striped() {
      return this.$store.getters.current_body_theme_striped.background === undefined ? { "background": "#6c757d", "color": "#fff" } : this.$store.getters.current_body_theme_striped;
    },
  },
  mounted() {
    // 处理手机端默认隐藏菜单
    if (this.IsMobile() != null) {
      //this.handleMenu();
      this.$store.state.tab.isCollapse = true;
    }
    // this.$nextTick(() => {
    //   // 导航栏主题
    //   this.set_theme(".el-breadcrumb__inner");
    //   this.set_theme(".el-breadcrumb__separator");

    // });
  },
  updated() {
    // this.$nextTick(() => {
    //   // 导航栏主题
    //   this.set_theme(".el-breadcrumb__inner");
    //   this.set_theme(".el-breadcrumb__separator");

    // });
  },
  watch: {
    // 處理路由切換緩存失效問題
    $route() {
      // 处理动态路由多语言拼接
      /* if (this.$route.params != undefined && this.$route.params.actione_type != "") {
        var item = this.$store.state.tab.tabList.filter(item => item.name === this.$route.name)[0];
        if (this.$route.params.actione_type === "add")
          item.label = this.$t(item.label).replace("[" + this.$t('_new') + "]","") + "[" + this.$t('_new') + "]"
        else if (this.$route.params.actione_type === "edit")
          item.label = this.$t(item.label).replace("[" + this.$t('_edit') + "]", "") + "[" + this.$t('_edit') + "]"
        else if (this.$route.params.actione_type === "V")
          item.label = this.$t(item.label).replace("[" + this.$t('_view') + "]", "") + "[" + this.$t('_view') + "]"
      } */
      setTimeout(() => {
        var items = this.$store.state.tab.tabList.filter(item => item.name === this.$route.name);
        items.length > 0 && this.changeMenu(items[0]);
      }, 0);
    },
    nextLabel: {
      handler(val) {
        if (val) {
          var tag = this.tags.filter(item => item.name === val || item.name === val + '_edit');
          if (tag.length > 0) {
            this.changeMenu(tag[0]);
          }
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.header-container {
  padding: 0 12px;
  background-color: #ffffff;
  display: flex;
  justify-content: space-between; //水平布局
  align-items: center; // 垂直布局 */

  .text {
    color: #5b5b62;
    font-size: 14px;
    margin-left: 10px;
  }

  .r-content {
    display: flex;
    align-items: center;
    flex-grow: 0;
    //min-width: 190px;

    .user {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }
  }

  .l-content {
    display: flex;
    align-items: center;
    flex-grow: 0;

    .content-hamburger {
      height: 25px;
      cursor: pointer;
    }

    // data-随机数 加上deep样式穿刺解决
    /deep/.el-breadcrumb__item {
      .el-breadcrumb__inner {
        font-weight: normal;

        // 并且
        &.is-link {
          color: #666;
        }
      }

      //伪类最后一个子元素
      &:last-child {
        .el-breadcrumb__inner {
          color: #5b5b62;
        }
      }
    }

    .hamburger {
      display: inline-block;
      vertical-align: middle;
      width: 20px;
      height: 20px;
      margin-right: 20px;
    }

    .hamburger.is-active {
      transform: rotate(180deg);
    }

    .center-dialog {
      top: 45%;
      transform: translateY(-50%);
    }
  }
}

.tabs {
  height: 42px; //默認34px
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);
  display: flex;
  align-items: center;

  .el-tag {
    margin-right: 5px;
    cursor: pointer;
    border-radius: 0;
  }

  .tag-active {
    content: "";
    background: #fff;
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    position: relative;
    bottom: 2px;
  }

  .el-tag--dark {
    background-color: rgb(60, 141, 188);
    border-color: rgb(60, 141, 188);
    color: black;
  }

  .el-tag--plain {
    border: 1px solid #d8dce5;
    color: #495060;
  }

  // 关闭选项卡样式
  /deep/.el-icon-close {
    width: 32px;
    height: 30px;
    line-height: 30px;
    border-radius: 100%;
    position: relative;
    top: 0px;
    font-size: 20px;
    vertical-align: baseline;
    text-align: center;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    transform-origin: 100% 50%;

    &:hover {
      background-color: #b4bccc;
      color: #fff;
    }
  }

  /deep/.el-tag--plain .el-tag__close {
    color: #495060;
  }

  .scroll-container {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    overflow: auto;
    // background: #fff;
    flex-grow: 1;
    height: 100%;
  }
}

// 移除選項卡y軸滾動
/deep/.el-scrollbar__bar.is-vertical>div {
  width: 0%;
}

::-webkit-scrollbar {
  /*滾動條整體樣式*/
  width: 1px !important;
  /*高寬分別對應橫豎滾動條的尺寸*/
  height: 8px;
}

::-webkit-scrollbar-thumb {
  /*滾動條裏面小方塊*/
  border-radius: 10px;
  //background-color: #8c8c8c;
  background-color: rgba(0, 0, 0, 0.25);
}

::-webkit-scrollbar-track {
  background-color: #f6f6f6;
}

::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
  border: 0;
}
</style>
